export const DEFAULT_REFERRAL_POST_CLOCK_OUT_CTA_CONFIG = {
  enabled: false,
} as const;
